/**
 * CashFlowPrint — impression du Tableau de flux de trésorerie.
 * Réutilise la PAGE RÉELLE de l'écran (CashFlowPage en mode embedded/actualsOnly)
 * : mêmes colonnes (N-1 / N), cascade complète + réconciliation au bilan. Le
 * décor interactif (barre Mapping, alerte non-classé) est masqué par CSS. Unité
 * = celle du hub États financiers. `onReady` (déclenché une fois) signale au host
 * d'impression que les données sont chargées.
 */
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CashFlowPage from '../CashFlowPage';
import { usePersistentValue } from '../../hooks/usePersistentState';
import { p } from '../../i18n/useP';
import PrintReportHeader from '../hr/print/PrintReportHeader';
import '../hr/print/PeoplePrint.css';
import './financialsScreenPrint.css';

const noop = () => {};

export default function CashFlowPrint({ activeTenant, year, editedAt, onDataReady, cutoff = null }) {
  const { t } = useTranslation();
  const tenantId = activeTenant?.id;
  const [unit] = usePersistentValue(`fin_reports_unit_${tenantId}`, 'kchf');
  const done = useRef(false);
  const ready = () => { if (!done.current) { done.current = true; if (onDataReady) onDataReady('financials-cf'); } };

  return (
    <section className="ppl-print__section ppl-print__section--wide fin-screenprint">
      <PrintReportHeader category={p('Rapport financier')} title={t('phrases:p_5581d03326')} year={year} unit={unit} tenant={activeTenant} editedAt={editedAt} />
      <CashFlowPage embedded actualsOnly standard cutoff={cutoff} unit={unit} activeTenant={activeTenant} year={year} addToast={noop} onReady={ready} />
    </section>
  );
}
